import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

export const firebaseConfig = {
  apiKey: "AIzaSyC_zNkdA1Q14LqgEfRDOGjgT-0LmCfutKE",
  authDomain: "lkpartygames.firebaseapp.com",
  databaseURL: "https://lkpartygames-default-rtdb.firebaseio.com",
  projectId: "lkpartygames",
  storageBucket: "lkpartygames.firebasestorage.app",
  messagingSenderId: "398642503535",
  appId: "1:398642503535:web:8578e69686f1eec64b529a",
};

export const app = getApps()[0] ?? initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
